import { render } from "./humanityLibraryManage.vue?vue&type=template&id=e85ca32c&scoped=true"
import script from "./humanityLibraryManage.vue?vue&type=script&lang=js"
export * from "./humanityLibraryManage.vue?vue&type=script&lang=js"

import "./humanityLibraryManage.vue?vue&type=style&index=0&id=e85ca32c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e85ca32c"]])

export default __exports__